<template>
  <div>
    <p v-if="mat">
      Matricula : {{ mat }}
    </p>
    <p> {{ nombre }}</p>
    <b-list-group
      v-for="(item, index) of materias"
      :key="`lista-${index}`"
    >
      <b-list-group-item class="d-flex justify-content-between align-items-center">
        <span>{{ item.nombre }}</span>
        <b-badge
          variant="light-primary"
          pill
          class="badge-round"
        >
          {{ item.status }}
        </b-badge>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import {
  BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import {
  onMounted,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useBajasMateriasA } from './useBaja'

export default {
  components: {
    BListGroup, BListGroupItem, BBadge,
  },
  props: {
    ag: {
      type: [Number, null],
      default: null,
    },
    mat: {
      type: [Number, null],
      default: null,
    },
    nombre: {
      type: [String, null],
      default: null,
    },
  },
  setup(props) {
    const toast = useToast()
    const {
      materias, materiasPromise,
    } = useBajasMateriasA(props.ag)

    onMounted(() => {
      Promise.all([materiasPromise])
        .then(() => { })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error del servicio',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    })
    return {
      materias,
    }
  },
}
</script>
